/*
Lo que pasa es que jquery tiene su propio sistema de gestión de eventos y
los eventos que lanza jquery no se pueden capturar desde javascript plano.
Para que vue pueda coger los datos y hacer el binding con el data etc,
aquí usamos una serie de funciones para adaptar el funcionamiento que
tienen estos componentes y que los podamos usar en componentes Vue sin
tener que duplicar todos los componentes
*/
/* global $ */
export function vue_select2_adapter(element) {
  $(element).on('change', function onChange(_e) {
    console.log(_e);
    // Siempre trata los valores como strings
    if (this.dataset.lanzando !== 'true') {
      this.dataset.lanzando = 'true';
      this.dispatchEvent(new Event('change'));
      this.dataset.lanzando = 'false';
    }
  });
}

// Wrapper para que funcione bootstrap-datepicker con Vue
// OJO!!!!! No sé por qué datepicker lanza el evento change muchas veces.
// De momento lo dejo, si tenemos efectos secundarios habría que revisar
export function vue_datepicker_adapter(element) {
  $(element).on('change', function onChange(e) {
    this.dispatchEvent(new Event('input'));
  });
}

export function vueAdaptAll(element) {
  const padre = $(element);
  // Habría que mirar si se puede quitar esto ya
  padre.find('[data-controller="select2"]').each(function load() {
    vue_select2_adapter(this);
  });
  padre.find('.cifra_date').each(function load() {
    vue_datepicker_adapter(this);
  });
}
